// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2fkiG","approved":"Status_approved__3_o_w","rejected":"Status_rejected__1Ps6y","expired":"Status_expired__38YHr","label":"Status_label__1HZc-"};